import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../utils/postData";

export const createInitiative = createAsyncThunk(
  "initiatives/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await postData(
        `${process.env.REACT_APP_BASE_URL}api/initiatives`,
        data
      );
      if (!response || !response.success) {
        return rejectWithValue(response?.message || "Failed to create initiative");
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to create initiative");
    }
  }
);
